import React, { useMemo, useState } from 'react';
import Grid from "@mui/material/Grid2";
import SelectDropdown from "./SelectDropdownComponent";
import {useFilterDataContext} from "../Context/FilterDataContext";
import {Button} from "semantic-ui-react";

const MoreFiltersComponent = React.memo(() => {
    const [activeSwitch, setActiveSwitch] = useState(null);
    const { setFilteredData } = useFilterDataContext();

    const handleSwitchChange = (title) => {
        setActiveSwitch(activeSwitch === title ? null : title);
    };

    const handleResetAll = () => {
        setFilteredData({});
        setActiveSwitch(null);
        localStorage.removeItem("filteredData");
    };

    const defaults = useMemo(() => ({
        destinations: JSON.parse(localStorage.getItem("destinations")) ?? [],
        produits: JSON.parse(localStorage.getItem("produits")) ?? [],
        commerciaux: JSON.parse(localStorage.getItem("commerciaux")) ?? [],
        reseaux: JSON.parse(localStorage.getItem("reseaux")) ?? [],
        marques: JSON.parse(localStorage.getItem("marques")) ?? [],
        departements: JSON.parse(localStorage.getItem("departements")) ?? [],
        vendeurs: JSON.parse(localStorage.getItem("vendeurs")) ?? [],
        statutsDossier: JSON.parse(localStorage.getItem("statutsDossier")) ?? [],
        clients: JSON.parse(localStorage.getItem("clients")) ?? [],
        fournisseur: JSON.parse(localStorage.getItem("fournisseur")) ?? []
    }), []);

    return (
        <Grid container sx={{
            display: 'flex',
            justifyContent: {
                xs: 'center',
                md: 'flex-start',
            },
        }}>
            <Grid item xs={12} sm={6} md={4} lg={2}>
                <SelectDropdown toggle={true} title={'Destinations'}
                                isActive={activeSwitch === 'Destinations'}
                                onSwitchChange={handleSwitchChange}
                                defaultData={defaults.destinations}/>
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={2}>
                <SelectDropdown toggle={true} title={'Produits'}
                                isActive={activeSwitch === 'Produits'}
                                onSwitchChange={handleSwitchChange}
                                defaultData={defaults.produits}/>
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={2}>
                <SelectDropdown toggle={true} title={'Commercial'}
                                isActive={activeSwitch === 'Commercial'}
                                onSwitchChange={handleSwitchChange}
                                defaultData={defaults.commerciaux}/>
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={2}>
                <SelectDropdown toggle={true} title={'Reseau'}
                                isActive={activeSwitch === 'Reseau'}
                                onSwitchChange={handleSwitchChange}
                                defaultData={defaults.reseaux}/>
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={2}>
                <SelectDropdown toggle={true} title={'Marque'}
                                isActive={activeSwitch === 'Marque'}
                                onSwitchChange={handleSwitchChange}
                                defaultData={defaults.marques}/>
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={2}>
                <SelectDropdown toggle={true} title={'Departement'}
                                isActive={activeSwitch === 'Departement'}
                                onSwitchChange={handleSwitchChange}
                                defaultData={defaults.departements}/>
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={2}>
                <SelectDropdown toggle={true} title={'Vendeur'}
                                isActive={activeSwitch === 'Vendeur'}
                                onSwitchChange={handleSwitchChange}
                                defaultData={defaults.vendeurs}/>
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={2}>
                <SelectDropdown toggle={true} title={'Statut'}
                                isActive={activeSwitch === 'Statut'}
                                onSwitchChange={handleSwitchChange}
                                defaultData={defaults.statutsDossier}/>
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={2}>
                <SelectDropdown toggle={true} title={'Client'}
                                isActive={activeSwitch === 'Client'}
                                onSwitchChange={handleSwitchChange}
                                defaultData={defaults.clients}/>
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={2}>
                <SelectDropdown toggle={true} title={'Fournisseur'}
                                isActive={activeSwitch === 'Fournisseur'}
                                onSwitchChange={handleSwitchChange}
                                defaultData={defaults.fournisseur}/>
            </Grid>
            <Grid container justifyContent="center" sx={{ marginTop: 3 }}>
                <Button
                    onClick={handleResetAll}
                    className="button moreFilterButton my-xxl-0 my-md-2"
                >
                    Réinitialiser
                </Button>
            </Grid>

        </Grid>
    )
});

export { MoreFiltersComponent };
